export const products = [
  {
    id: 1,
    slug: 'signature-matte-white-54',
    name: 'Signature Matte White - 54"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets.emergentagent.com/job_luxury-fans/artifacts/zvhiinyw_WhatsApp%20Image%202026-01-24%20at%201.20.44%20PM%20%284%29.jpeg',
    description: 'The Signature Matte White is a stunning 54" ceiling fan that combines elegant aesthetics with powerful performance. Designed for modern interiors, this fan features a sleek matte white finish that complements any décor while delivering whisper-quiet operation.\n\nCrafted with precision engineering, the Signature series represents the pinnacle of Bernard Fan Co.\'s commitment to luxury and functionality. The aerodynamically designed blades ensure optimal air circulation while maintaining energy efficiency.',
    generalSpec: [
      { label: 'Model', value: 'Signature Matte White' },
      { label: 'Blade Span', value: '54 inches' },
      { label: 'Number of Blades', value: '5' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '153*8mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '6 - 38' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '94 - 198' },
      { label: 'Airflow (CFM)', value: '3900 - 9500' },
      { label: 'Noise Level', value: '42 dB - 48 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 2,
    slug: 'signature-coffee-silver-54',
    name: 'Signature Coffee Silver - 54"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets.emergentagent.com/job_luxury-fans/artifacts/azhqz9bf_WhatsApp%20Image%202026-01-24%20at%201.20.43%20PM%20%285%29.jpeg',
    description: 'The Signature Coffee Silver is a sophisticated 54" ceiling fan featuring a stunning Charcoal Grey color combination. This elegant fan brings warmth and refinement to any space while delivering exceptional airflow performance.\n\nThe Signature series showcases Bernard Fan Co.\'s dedication to creating fans that are both functional masterpieces and design statements. Perfect for living rooms, bedrooms, and dining areas.',
    generalSpec: [
      { label: 'Model', value: 'Signature Coffee Silver' },
      { label: 'Blade Span', value: '54 inches' },
      { label: 'Number of Blades', value: '5' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '153*8mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '6 - 38' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '94 - 198' },
      { label: 'Airflow (CFM)', value: '3900 - 9500' },
      { label: 'Noise Level', value: '42 dB - 48 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 3,
    slug: 'signature-wood-black-54',
    name: 'Signature Dark Wood + Black - 54"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets.emergentagent.com/job_luxury-fans/artifacts/1ntjh108_WhatsApp%20Image%202026-01-24%20at%201.20.43%20PM%20%284%29.jpeg',
    description: 'The Signature Wood + Black is a striking 54" ceiling fan that beautifully combines natural wood tones with sophisticated black accents. This fan creates a perfect balance between rustic charm and modern elegance.\n\nIdeal for contemporary and transitional interiors, this fan delivers powerful yet whisper-quiet performance while serving as a stunning focal point in any room.',
    generalSpec: [
      { label: 'Model', value: 'Signature Dark Wood + Black' },
      { label: 'Blade Span', value: '54 inches' },
      { label: 'Number of Blades', value: '5' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '153*8mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '6 - 38' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '94 - 198' },
      { label: 'Airflow (CFM)', value: '3900 - 9500' },
      { label: 'Noise Level', value: '42 dB - 48 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 23,
    slug: 'signature-light-wood-white-54',
    name: 'Signature Light Wood + White - 54"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets.emergentagent.com/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/ccg35qwv_WhatsApp%20Image%202026-06-29%20at%2011.43.29%20AM.jpeg',
    description: 'The Signature Light Wood + White is an elegant 54" ceiling fan that pairs warm light wood blades with a crisp white finish. This refined combination brings natural warmth and a clean, contemporary aesthetic to any living space.\n\nPart of the Signature series, this fan delivers whisper-quiet performance and powerful air circulation, making it a perfect statement piece for modern interiors, open-plan living areas, and bedrooms.',
    generalSpec: [
      { label: 'Model', value: 'Signature Light Wood + White' },
      { label: 'Blade Span', value: '54 inches' },
      { label: 'Number of Blades', value: '5' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '153*8mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '6 - 38' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '94 - 198' },
      { label: 'Airflow (CFM)', value: '3900 - 9500' },
      { label: 'Noise Level', value: '42 dB - 48 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 24,
    slug: 'signature-coffee-54',
    name: 'Signature Coffee - 54"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets.emergentagent.com/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/lrbon3u1_WhatsApp%20Image%202026-06-29%20at%2011.44.07%20AM.jpeg',
    description: 'The Signature Coffee is a refined 54" ceiling fan featuring warm coffee-toned blades that bring a sense of understated luxury to any room. Its rich, natural finish pairs beautifully with both modern and classic interiors.\n\nPart of the Signature series, this fan delivers whisper-quiet performance and powerful air circulation, making it an elegant centerpiece for living rooms, bedrooms, and open-plan spaces.',
    generalSpec: [
      { label: 'Model', value: 'Signature Coffee' },
      { label: 'Blade Span', value: '54 inches' },
      { label: 'Number of Blades', value: '5' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '153*8mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '6 - 38' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '94 - 198' },
      { label: 'Airflow (CFM)', value: '3900 - 9500' },
      { label: 'Noise Level', value: '42 dB - 48 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 25,
    slug: 'classic-dark-wood-black-60',
    name: 'Classic Dark Wood + Black - 60"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets.emergentagent.com/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/lzmwv364_WhatsApp%20Image%202026-06-29%20at%2011.55.12%20AM.jpeg',
    description: 'The Classic Dark Wood + Black is a grand 60" ceiling fan that pairs rich dark wood blades with a sleek black housing. This striking combination brings warmth and bold sophistication to larger spaces.\n\nThe Classic series embodies timeless design principles while incorporating the latest in fan technology, delivering exceptional air circulation for living rooms, master bedrooms, and open-plan areas.',
    generalSpec: [
      { label: 'Model', value: 'Classic Dark Wood + Black' },
      { label: 'Blade Span', value: '60 inches' },
      { label: 'Number of Blades', value: '3' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '153*18mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '8 - 36' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '90 - 174' },
      { label: 'Airflow (CFM)', value: '5300 - 10400' },
      { label: 'Noise Level', value: '43 dB - 49 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 4,
    slug: 'classic-matte-white-60',
    name: 'Classic Matte White - 60"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets.emergentagent.com/job_luxury-fans/artifacts/7nmya6s6_WhatsApp%20Image%202026-01-24%20at%201.20.46%20PM%20%285%29.jpeg',
    description: 'The Classic Matte White is a grand 60" ceiling fan designed for larger spaces. With its clean matte white finish and expansive blade span, this fan provides exceptional air circulation for living rooms, master bedrooms, and open-plan areas.\n\nThe Classic series embodies timeless design principles while incorporating the latest in fan technology for superior performance and efficiency.',
    generalSpec: [
      { label: 'Model', value: 'Classic Matte White' },
      { label: 'Blade Span', value: '60 inches' },
      { label: 'Number of Blades', value: '3' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '153*18mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '8 - 36' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '90 - 174' },
      { label: 'Airflow (CFM)', value: '5300 - 10400' },
      { label: 'Noise Level', value: '43 dB - 49 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 5,
    slug: 'classic-coffee-silver-60',
    name: 'Classic Coffee Silver - 60"',
    collection: 'ceiling-fans',
    image: '/images/fans/modern-ceiling-fan-hero.jpeg',
    description: 'The Classic Coffee Silver is a magnificent 60" ceiling fan that brings warmth and sophistication to larger spaces. The rich Charcoal Grey color combination creates an elegant aesthetic that complements both traditional and contemporary interiors.\n\nPerfect for spacious living areas, this fan delivers powerful airflow while maintaining the whisper-quiet operation Bernard Fan Co. is known for.',
    generalSpec: [
      { label: 'Model', value: 'Classic Coffee Silver' },
      { label: 'Blade Span', value: '60 inches' },
      { label: 'Number of Blades', value: '3' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '153*18mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '8 - 36' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '90 - 174' },
      { label: 'Airflow (CFM)', value: '5300 - 10400' },
      { label: 'Noise Level', value: '43 dB - 49 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 6,
    slug: 'platinum-matte-black-gold-52',
    name: 'Platinum Matte Black + Gold - 52"',
    collection: 'ceiling-fans',
    image: '/images/fans/WhatsApp Image 2026-01-24 at 1.20.42 PM (2).jpeg',
    description: 'The Platinum Matte Black + Gold is a luxurious 52" ceiling fan that makes a bold statement. The dramatic combination of matte black with gold accents creates an opulent aesthetic perfect for upscale interiors.\n\nThis fan is designed for those who appreciate the finer things in life. It delivers exceptional performance while serving as a stunning centerpiece in any room.',
    generalSpec: [
      { label: 'Model', value: 'Platinum Matte Black + Gold' },
      { label: 'Blade Span', value: '52 inches' },
      { label: 'Number of Blades', value: '6' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'Plywood' },
      { label: 'Motor Spec', value: '153*18mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '6 - 43' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '102 - 200' },
      { label: 'Airflow (CFM)', value: '4400 - 9000' },
      { label: 'Noise Level', value: '44 dB - 49 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 7,
    slug: 'phoenix-matte-black-walnut-52',
    name: 'Phoenix Matte Black + Walnut - 52"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets.emergentagent.com/job_luxury-fans/artifacts/i2orfqjx_WhatsApp%20Image%202026-01-24%20at%201.20.41%20PM%20%283%29.jpeg',
    description: 'The Phoenix Matte Black + Walnut is a distinguished 52" ceiling fan that combines the sophistication of matte black with the natural beauty of walnut wood. This fan brings an organic warmth to modern spaces.\n\nThe Phoenix series is designed for those who appreciate the harmony between natural materials and contemporary design. It delivers powerful performance while adding character to any room.',
    generalSpec: [
      { label: 'Model', value: 'Phoenix Matte Black + Walnut' },
      { label: 'Blade Span', value: '52 inches' },
      { label: 'Number of Blades', value: '5' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'Plywood' },
      { label: 'Motor Spec', value: '153*18mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '7 - 34' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '117 - 217' },
      { label: 'Airflow (CFM)', value: '4100 - 7700' },
      { label: 'Noise Level', value: '43 dB - 49 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 8,
    slug: 'titanium-matte-silver-grey-52',
    name: 'Titanium Matte Silver + Grey - 52"',
    collection: 'ceiling-fans',
    image: '/images/fans/WhatsApp Image 2026-01-24 at 1.20.42 PM (3).jpeg',
    description: 'The Titanium Matte Silver + Grey is an aerodynamic 52" ceiling fan with a contemporary industrial aesthetic. The sophisticated silver and grey color palette creates a modern look that complements minimalist and industrial interiors.\n\nBuilt with precision engineering, the Titanium series delivers exceptional airflow while maintaining the quiet operation that Bernard Fan Co. is renowned for.',
    generalSpec: [
      { label: 'Model', value: 'Titanium Matte Silver + Grey' },
      { label: 'Blade Span', value: '52 inches' },
      { label: 'Number of Blades', value: '6' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '153*18mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '6 - 43' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '92 - 183' },
      { label: 'Airflow (CFM)', value: '3700 - 8400' },
      { label: 'Noise Level', value: '44 dB - 49 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 9,
    slug: 'desert-sand-gold-56',
    name: 'Desert Sand Gold - 56"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets.emergentagent.com/job_luxury-fans/artifacts/mqrgouuf_WhatsApp%20Image%202026-01-24%20at%201.20.43%20PM%20%283%29.jpeg',
    description: 'The Desert Sand Gold is an elegant 56" ceiling fan inspired by the warm tones of desert landscapes. This fan features a beautiful sand and gold finish that adds warmth and sophistication to any space.\n\nPerfect for creating a cozy yet luxurious atmosphere, this fan delivers excellent airflow while serving as a stunning decorative element.',
    generalSpec: [
      { label: 'Model', value: 'Desert Sand Gold' },
      { label: 'Blade Span', value: '56 inches' },
      { label: 'Number of Blades', value: '5' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '160*15mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '6 - 51' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '62 - 140' },
      { label: 'Airflow (CFM)', value: '4000 - 10000' },
      { label: 'Noise Level', value: '44 dB - 49 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 10,
    slug: 'tropical-coffee-silver-brown-53',
    name: 'Tropical Coffee Silver + Brown - 53"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets.emergentagent.com/job_luxury-fans/artifacts/8k18wcpf_WhatsApp%20Image%202026-01-24%20at%201.20.46%20PM%20%286%29.jpeg',
    description: 'The Tropical Coffee Silver + Brown is a distinctive 53" ceiling fan featuring palm-leaf inspired blades in rich coffee and brown tones with silver accents. This fan brings a touch of tropical elegance to any space.\n\nIdeal for creating a resort-like atmosphere in your home, this fan combines unique aesthetics with powerful performance.',
    generalSpec: [
      { label: 'Model', value: 'Tropical Coffee Silver + Brown' },
      { label: 'Blade Span', value: '53 inches' },
      { label: 'Number of Blades', value: '5' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '153*18mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '5 - 40' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '112 - 234' },
      { label: 'Airflow (CFM)', value: '3700 - 7700' },
      { label: 'Noise Level', value: '44 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 26,
    slug: 'tropical-light-wood-white-53',
    name: 'Tropical Light Wood + White - 53"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets.emergentagent.com/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/arovkmvn_WhatsApp%20Image%202026-06-29%20at%2011.59.25%20AM.jpeg',
    description: 'The Tropical Light Wood + White is a distinctive 53" ceiling fan featuring palm-leaf inspired blades in warm light wood tones paired with a crisp white finish. This fan brings a breezy, resort-like elegance to any space.\n\nIdeal for creating a relaxed coastal or tropical atmosphere in your home, this fan combines unique aesthetics with powerful, whisper-quiet performance.',
    generalSpec: [
      { label: 'Model', value: 'Tropical Light Wood + White' },
      { label: 'Blade Span', value: '53 inches' },
      { label: 'Number of Blades', value: '5' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '153*18mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '5 - 40' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '112 - 234' },
      { label: 'Airflow (CFM)', value: '3700 - 7700' },
      { label: 'Noise Level', value: '44 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 11,
    slug: 'victorian-matte-white-52',
    name: 'Victorian Matte White - 52"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets.emergentagent.com/job_luxury-fans/artifacts/o0nzztd0_WhatsApp%20Image%202026-01-28%20at%2011.30.20%20AM.jpeg',
    description: 'The Victorian Matte White is a classic 52" ceiling fan that pays homage to timeless Victorian design. With its elegant matte white finish and traditional styling, this fan is perfect for classic and vintage-inspired interiors.\n\nThis fan combines old-world charm with modern technology, delivering efficient and quiet operation while maintaining its classic aesthetic appeal.',
    generalSpec: [
      { label: 'Model', value: 'Victorian Matte White' },
      { label: 'Blade Span', value: '52 inches' },
      { label: 'Number of Blades', value: '5' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'Plywood' },
      { label: 'Motor Spec', value: '153*18mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '7 - 34' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '117 - 217' },
      { label: 'Airflow (CFM)', value: '4100 - 7700' },
      { label: 'Noise Level', value: '43 dB - 49 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 12,
    slug: 'marvel-coffee-silver-29',
    name: 'Marvel Coffee Silver - 29"',
    collection: 'light-fans',
    image: '/images/fans/light-fan-hero.jpeg',
    description: 'The Marvel Coffee Silver is a Bladeless 29" light fan that combines elegant illumination with efficient air circulation. Perfect for smart spaces, this fan features a sophisticated coffee silver finish that adds a touch of luxury to any room.\n\nDesigned for versatility, the Marvel series delivers both ambient lighting and refreshing breeze in one stylish package, making it ideal for bedrooms, offices, and dining areas.',
    generalSpec: [
      { label: 'Model', value: 'Marvel Coffee Silver' },
      { label: 'Fan Size', value: '29 inches' },
      { label: 'Number of Blades', value: 'Bladeless' },
      { label: 'Housing Material', value: 'ABS Plastic' },
      { label: 'Blade Material', value: '-' },
      { label: 'Motor Spec', value: '172*22mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' },
      { label: 'Light Kit', value: 'LED*24W/3 colours + dimming + 10W (side light)' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '8 - 59' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '100 - 250' },
      { label: 'Airflow (CFM)', value: '2400 - 6100' },
      { label: 'Noise Level', value: '42 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 32,
    slug: 'sunshine-sand-gold-30',
    name: 'Sunshine Sand Gold - 30"',
    collection: 'light-fans',
    image: 'https://customer-assets.emergentagent.com/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/crxwt50b_WhatsApp%20Image%202026-06-29%20at%2012.35.38%20PM.jpeg',
    description: 'The Sunshine Sand Gold is a striking 30" light fan featuring a radiant sunburst blade design in warm sand gold tones surrounding an integrated illuminated disc. This fan doubles as a stunning decorative centrepiece while delivering gentle air circulation.\n\nDesigned for ambient lighting and refined style, the Sunshine series brings a warm, luxurious glow to bedrooms, dining areas, and intimate living spaces.',
    generalSpec: [
      { label: 'Model', value: 'Sunshine Sand Gold' },
      { label: 'Fan Size', value: '30 inches' },
      { label: 'Number of Blades', value: '15' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '153*18mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' },
      { label: 'Light Kit', value: 'LED*75W/3 colours' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '7 - 44' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '160 - 315' },
      { label: 'Airflow (CFM)', value: '2500 - 5200' },
      { label: 'Noise Level', value: '44 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 33,
    slug: 'spanish-latte-coffee-22',
    name: 'Spanish Latte Coffee - 22"',
    collection: 'fandeliers',
    image: 'https://customer-assets.emergentagent.com/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/ggnyioyx_WhatsApp%20Image%202026-06-29%20at%2012.51.37%20PM.jpeg',
    description: 'The Spanish Latte Coffee is an elegant 22" fandelier that blends the sculptural presence of a chandelier with the functionality of a ceiling fan. Featuring warm latte-toned rings and an integrated illuminated disc, it creates a sophisticated focal point in any room.\n\nDesigned for ambient lighting and gentle air circulation, the Spanish Latte Coffee brings a refined, contemporary glow to dining areas, bedrooms, and intimate living spaces.',
    generalSpec: [
      { label: 'Model', value: 'Spanish Latte Coffee' },
      { label: 'Fan Size', value: '22 inches' },
      { label: 'Number of Blades', value: '6' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '110*8mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' },
      { label: 'Light Kit', value: 'LED*120W/3 colours' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '6 - 21' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '325 - 605' },
      { label: 'Airflow (CFM)', value: '800 - 1800' },
      { label: 'Noise Level', value: '44 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 34,
    slug: 'cobweb-wood-black-20',
    name: 'Cobweb Wood + Black 20"',
    collection: 'fandeliers',
    image: 'https://customer-assets.emergentagent.com/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/ufshcvhn_WhatsApp%20Image%202026-06-29%20at%201.15.39%20PM.jpeg',
    description: 'The Cobweb Wood + Black is a bold 20" fandelier that fuses an industrial caged frame with warm wooden blades and an integrated illuminated ring. Its sculptural, web-like silhouette makes a dramatic statement in any space.\n\nDesigned for ambient lighting and gentle air circulation, the Cobweb brings rustic-modern character to dining areas, kitchens, and contemporary living spaces.',
    generalSpec: [
      { label: 'Model', value: 'Cobweb Wood + Black' },
      { label: 'Fan Size', value: '20 inches' },
      { label: 'Number of Blades', value: '6' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '110*8mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' },
      { label: 'Light Kit', value: 'LED*18W/3 colours + Dimming' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '4 - 17' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '595 - 1140' },
      { label: 'Airflow (CFM)', value: '600 - 1100' },
      { label: 'Noise Level', value: '44 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 35,
    slug: 'glitz-matte-white-42',
    name: 'Glitz Matte White 42"',
    collection: 'fandeliers',
    image: 'https://customer-assets.emergentagent.com/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/cj0agxet_WhatsApp%20Image%202026-06-29%20at%201.21.53%20PM.jpeg',
    description: 'The Glitz Matte White is an elegant 42" fandelier featuring retractable blades and a sparkling matte white ring with an integrated illuminated disc. When at rest it reads as a refined chandelier; in motion it delivers gentle, whisper-quiet air circulation.\n\nDesigned for ambient lighting and effortless style, the Glitz brings a touch of understated glamour to dining areas, bedrooms, and contemporary living spaces.',
    generalSpec: [
      { label: 'Model', value: 'Glitz Matte White' },
      { label: 'Fan Size', value: '42 inches' },
      { label: 'Number of Blades', value: '4' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '75*10mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' },
      { label: 'Light Kit', value: 'LED*60W/3 colours' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '4 - 15' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '165 - 235' },
      { label: 'Airflow (CFM)', value: '2800 - 5300' },
      { label: 'Noise Level', value: '44 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 36,
    slug: 'dazzle-golden-42',
    name: 'Dazzle Golden - 42"',
    collection: 'fandeliers',
    image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/c85d207366f008e7_WhatsApp%20Image%202026-10-29%20at%2011.15.21%20AM%20%281%29.jpeg',
    description: 'The Dazzle Golden is a sophisticated 42" fandelier featuring retractable blades and a luminous golden ring with an integrated illuminated disc. At rest it reads as a refined chandelier; in motion it delivers gentle, whisper-quiet air circulation.\n\nDesigned to bring warm, ambient lighting and effortless elegance, the Dazzle Golden is a stunning centrepiece for dining areas, bedrooms, and contemporary living spaces.',
    generalSpec: [
      { label: 'Model', value: 'Dazzle Golden' },
      { label: 'Fan Size', value: '42 inches' },
      { label: 'Number of Blades', value: '4' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '75*10mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' },
      { label: 'Light Kit', value: 'LED*60W/3 colours' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '5 - 31' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '147 - 239' },
      { label: 'Airflow (CFM)', value: '2900 - 5200' },
      { label: 'Noise Level', value: '44 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 37,
    slug: 'sparkle-light-silver-gold-31',
    name: 'Sparkle Light Silver + Gold - 31"',
    collection: 'fandeliers',
    image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/4274298e7e6b2b38_WhatsApp%20Image%202026-10-29%20at%2011.14.10%20AM%20%286%29.jpeg',
    description: 'The Sparkle Light Silver + Gold is a refined 31" fandelier featuring retractable blades and a dual-tier crystal ring in silver and gold with an integrated illuminated disc. At rest it presents as an elegant chandelier; in motion it delivers gentle, whisper-quiet air circulation.\n\nCompact yet luminous, the Sparkle brings a touch of glamour and warm ambient lighting to kitchens, dining nooks, bedrooms, and intimate contemporary spaces.',
    generalSpec: [
      { label: 'Model', value: 'Sparkle Light Silver + Gold' },
      { label: 'Fan Size', value: '31 inches' },
      { label: 'Number of Blades', value: '5' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '110*8mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' },
      { label: 'Light Kit', value: 'LED*75W/3 colors' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '3 - 14' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '200 - 450' },
      { label: 'Airflow (CFM)', value: '564 - 1621' },
      { label: 'Noise Level', value: '44 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 38,
    slug: 'salsa-coffee-silver-wood-42',
    name: 'Salsa Coffee Silver + Wood - 42"',
    collection: 'fandeliers',
    image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/661dac33709a4e97_WhatsApp%20Image%202026-10-29%20at%2011.14.10%20AM%20%287%29.jpeg',
    description: 'The Salsa Coffee Silver + Wood is a striking 42" fandelier that pairs warm wood-finished blades with a coffee silver housing and an integrated illuminated disc. Blending the presence of a ceiling fan with soft ambient lighting, it delivers powerful yet whisper-quiet air circulation.\n\nWith its refined blend of natural wood tones and contemporary metal finish, the Salsa makes an elegant centrepiece for dining rooms, living areas, and modern open-plan spaces.',
    generalSpec: [
      { label: 'Model', value: 'Salsa Coffee Silver + Wood' },
      { label: 'Fan Size', value: '42 inches' },
      { label: 'Number of Blades', value: '5' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '140*20mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' },
      { label: 'Light Kit', value: 'LED*46W/3 Colors + 13W(side Light)' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '5 - 36' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '127 - 232' },
      { label: 'Airflow (CFM)', value: '2700 - 6300' },
      { label: 'Noise Level', value: '44 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 13,
    slug: 'divine-matte-white-gold-52',
    name: 'Divine Matte White + Gold - 52"',
    collection: 'light-fans',
    image: 'https://customer-assets.emergentagent.com/job_luxury-fans/artifacts/fmzx0khs_WhatsApp%20Image%202026-01-26%20at%201.32.32%20PM%20%281%29.jpeg',
    description: 'The Divine Matte White + Gold is a luxurious 52" light fan that brings opulence to any space. Featuring a stunning combination of matte white with gold accents, this fan delivers both brilliant illumination and powerful airflow.\n\nThe Divine series represents the perfect marriage of form and function, offering adjustable lighting and multiple speed settings to create the ideal atmosphere for any occasion.',
    generalSpec: [
      { label: 'Model', value: 'Divine Matte White + Gold' },
      { label: 'Blade Span', value: '52 inches' },
      { label: 'Number of Blades', value: '3' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '160*15mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' },
      { label: 'Light Kit', value: 'LED*22W/3 colours + dimming' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '6 - 41' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '85 - 186' },
      { label: 'Airflow (CFM)', value: '4000 - 9400' },
      { label: 'Noise Level', value: '44 dB - 49 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 14,
    slug: 'divine-coffee-silver-bronze-52',
    name: 'Divine Coffee Silver + Bronze 52"',
    collection: 'light-fans',
    image: 'https://customer-assets.emergentagent.com/job_luxury-fans/artifacts/hr1qb3i5_WhatsApp%20Image%202026-01-24%20at%201.20.41%20PM%20%284%29.jpeg',
    description: 'The Divine Coffee Silver + Bronze is an elegant 52" light fan featuring a rich combination of coffee silver and bronze finishes. This fan creates a warm, inviting ambiance with its integrated lighting while providing excellent air circulation.\n\nPerfect for living rooms and dining areas, the Divine Coffee Silver + Bronze combines sophisticated styling with practical functionality.',
    generalSpec: [
      { label: 'Model', value: 'Divine Coffee Silver + Bronze' },
      { label: 'Blade Span', value: '52 inches' },
      { label: 'Number of Blades', value: '3' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '160*15mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' },
      { label: 'Light Kit', value: 'LED*22W/3 colours + dimming' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '6 - 41' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '85 - 186' },
      { label: 'Airflow (CFM)', value: '4000 - 9400' },
      { label: 'Noise Level', value: '44 dB - 49 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 15,
    slug: 'big-bird-wood-black-66',
    name: 'Big Bird Wood + Black - 66"',
    collection: 'oversized-fans',
    image: '/images/fans/oversized-fan-hero.jpeg',
    description: 'The Big Bird Wood + Black is a majestic 66" oversized ceiling fan designed for large spaces. Featuring a stunning combination of natural wood and black finishes, this fan delivers exceptional airflow while making a bold architectural statement.\n\nPerfect for high ceilings, open-plan living areas, and commercial spaces, the Big Bird series combines powerful performance with sophisticated design.',
    generalSpec: [
      { label: 'Model', value: 'Big Bird Wood + Black' },
      { label: 'Blade Span', value: '66 inches' },
      { label: 'Number of Blades', value: '6' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '160*15mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '6 - 53' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '53 - 115' },
      { label: 'Airflow (CFM)', value: '5800 - 12700' },
      { label: 'Noise Level', value: '30 dB - 48 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 27,
    slug: 'big-bird-matte-white-66',
    name: 'Big Bird Matte White - 66"',
    collection: 'oversized-fans',
    image: 'https://customer-assets.emergentagent.com/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/rfxyzjle_WhatsApp%20Image%202026-06-29%20at%2011.59.54%20AM.jpeg',
    description: 'The Big Bird Matte White is a majestic 66" oversized ceiling fan finished in a clean matte white. Designed for large spaces, this fan delivers exceptional airflow while making a bold yet refined architectural statement.\n\nPerfect for high ceilings, open-plan living areas, and commercial spaces, the Big Bird series combines powerful performance with sophisticated design.',
    generalSpec: [
      { label: 'Model', value: 'Big Bird Matte White' },
      { label: 'Blade Span', value: '66 inches' },
      { label: 'Number of Blades', value: '6' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '160*15mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '6 - 53' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '53 - 115' },
      { label: 'Airflow (CFM)', value: '5800 - 12700' },
      { label: 'Noise Level', value: '30 dB - 48 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 16,
    slug: 'big-bird-coffee-silver-66',
    name: 'Big Bird Coffee Silver - 66"',
    collection: 'oversized-fans',
    image: 'https://customer-assets.emergentagent.com/job_luxury-fans/artifacts/q3ndk1ae_WhatsApp%20Image%202026-01-24%20at%201.20.47%20PM%20%282%29.jpeg',
    description: 'The Big Bird Coffee Silver is a commanding 66" oversized ceiling fan featuring an elegant coffee silver finish. This fan is engineered to provide powerful airflow for expansive spaces while maintaining a refined aesthetic.\n\nIdeal for large living rooms, lobbies, and commercial venues, the Big Bird Coffee Silver combines industrial strength with sophisticated styling.',
    generalSpec: [
      { label: 'Model', value: 'Big Bird Coffee Silver' },
      { label: 'Blade Span', value: '66 inches' },
      { label: 'Number of Blades', value: '6' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '160*15mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '6 - 53' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '53 - 115' },
      { label: 'Airflow (CFM)', value: '5800 - 12700' },
      { label: 'Noise Level', value: '30 dB - 48 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 17,
    slug: 'grand-master-coffee-silver-78',
    name: 'Grand Master Coffee Silver - 78"',
    collection: 'oversized-fans',
    image: 'https://customer-assets.emergentagent.com/job_luxury-fans/artifacts/4inasl6j_WhatsApp%20Image%202026-01-24%20at%201.20.47%20PM%20%283%29.jpeg',
    description: 'The Grand Master Coffee Silver is an impressive 78" oversized ceiling fan, the largest in our collection. With its commanding presence and coffee silver finish, this fan is designed to dominate expansive spaces with powerful airflow.\n\nPerfect for warehouses, gymnasiums, large commercial spaces, and grand residential areas with high ceilings, the Grand Master delivers unmatched performance.',
    generalSpec: [
      { label: 'Model', value: 'Grand Master Coffee Silver' },
      { label: 'Blade Span', value: '78 inches' },
      { label: 'Number of Blades', value: '8' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'Aluminium' },
      { label: 'Motor Spec', value: '172*22mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' },
      { label: 'Light Kit', value: 'LED*36W/3 colours + 15W light' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '8 - 65' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '72 - 148' },
      { label: 'Airflow (CFM)', value: '8200 - 18500' },
      { label: 'Noise Level', value: '44 dB - 54 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 18,
    slug: 'cherry-dark-wood-black-32',
    name: 'Cherry Dark Wood + Black - 32"',
    collection: 'wall-fans',
    image: '/images/fans/wall-fan-hero.jpeg',
    description: 'The Cherry Dark Wood + Black is an elegant 32" wall fan that combines the warmth of cherry wood tones with sleek black accents. This compact yet powerful fan is perfect for spaces where ceiling mounting is not an option.\n\nDesigned for versatility, this wall fan delivers refreshing airflow while serving as a stylish decorative element. Ideal for bedrooms, living rooms, offices, and commercial spaces.',
    generalSpec: [
      { label: 'Model', value: 'Cherry Dark Wood + Black' },
      { label: 'Blade Span', value: '32 inches' },
      { label: 'Number of Blades', value: '4' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'Wooden' },
      { label: 'Motor Spec', value: '153*15mm DC motor' },
      { label: 'Remote Control', value: 'Yes' },
      { label: 'Fan Speed', value: '6 Speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '7 - 38' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '200 - 370' },
      { label: 'Airflow (CFM)', value: '1700 - 2600' },
      { label: 'Noise Level', value: '44dB - 50dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 19,
    slug: 'jasmine-dark-wood-black-52',
    name: 'Jasmine Dark Wood + Black 52"',
    collection: 'wall-fans',
    image: 'https://customer-assets.emergentagent.com/job_fanco-preview/artifacts/irf8hmla_WhatsApp%20Image%202026-01-24%20at%201.20.44%20PM%20%285%29.jpeg',
    description: 'The Jasmine Dark Wood + Black is a stunning 52" wall fan featuring elegant dark wood blades with sophisticated black accents. This larger wall fan provides exceptional airflow for bigger spaces while maintaining a refined aesthetic.\n\nPerfect for spacious living areas, restaurants, and commercial environments, the Jasmine combines powerful performance with timeless design.',
    generalSpec: [
      { label: 'Model', value: 'Jasmine Dark Wood + Black' },
      { label: 'Blade Span', value: '52 inches' },
      { label: 'Number of Blades', value: '4' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'Wooden' },
      { label: 'Motor Spec', value: '188*15mm AC motor' },
      { label: 'Remote Control', value: 'Yes' },
      { label: 'Fan Speed', value: '3 Speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '13 - 43' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '60 - 126' },
      { label: 'Airflow (CFM)', value: '1800 - 3700' },
      { label: 'Noise Level', value: '35 dB - 45 dB' },
      { label: 'Speed Settings', value: '3' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 20,
    slug: 'dynamite-matte-white-16',
    name: 'Dynamite Matte White - 16"',
    collection: 'multi-purpose-fans',
    image: '/images/fans/multi-purpose-fan-hero.jpeg',
    description: 'The Dynamite Matte White is a compact yet powerful 16" multi-purpose fan featuring a sleek matte white finish. This versatile fan can be mounted on walls and ceilings (with or without a fan rod), making it perfect for any space.\n\nDesigned for flexibility, the Dynamite series delivers efficient airflow in a compact form factor, ideal for kitchens, bathrooms, offices, and small rooms where space is at a premium.',
    generalSpec: [
      { label: 'Model', value: 'Dynamite Matte White' },
      { label: 'Blade Span', value: '16 inches' },
      { label: 'Number of Blades', value: '3' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '80mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '2 - 17' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '445 - 883' },
      { label: 'Airflow (CFM)', value: '700 - 1400' },
      { label: 'Noise Level', value: '32 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 21,
    slug: 'dynamite-coffee-silver-16',
    name: 'Dynamite Coffee Silver - 16"',
    collection: 'multi-purpose-fans',
    image: 'https://customer-assets.emergentagent.com/job_fanco-preview/artifacts/5o6fdby7_WhatsApp%20Image%202026-01-24%20at%201.20.42%20PM%20%284%29.jpeg',
    description: 'The Dynamite Coffee Silver is an elegant 16" multi-purpose fan featuring a sophisticated coffee silver finish. This versatile fan offers multiple mounting options including walls and different types of ceilings.\n\nPerfect for adding a touch of style to any space while providing efficient cooling, the Dynamite Coffee Silver combines compact design with powerful performance.',
    generalSpec: [
      { label: 'Model', value: 'Dynamite Coffee Silver' },
      { label: 'Blade Span', value: '16 inches' },
      { label: 'Number of Blades', value: '3' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '80mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '2 - 17' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '445 - 883' },
      { label: 'Airflow (CFM)', value: '700 - 1400' },
      { label: 'Noise Level', value: '32 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 22,
    slug: 'dynamite-wood-black-16',
    name: 'Dynamite Wood + Black - 16"',
    collection: 'multi-purpose-fans',
    image: 'https://customer-assets.emergentagent.com/job_fanco-preview/artifacts/fpynyavn_WhatsApp%20Image%202026-01-24%20at%201.20.45%20PM%20%283%29.jpeg',
    description: 'The Dynamite Wood + Black is a stylish 16" multi-purpose fan featuring beautiful wood-tone blades with sleek black accents. This versatile fan can be mounted on walls and different types of ceilings.\n\nBringing natural warmth to any space, the Dynamite Wood + Black combines aesthetic appeal with practical functionality, perfect for modern and rustic interiors alike.',
    generalSpec: [
      { label: 'Model', value: 'Dynamite Wood + Black' },
      { label: 'Blade Span', value: '16 inches' },
      { label: 'Number of Blades', value: '3' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '80mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '2 - 17' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '445 - 883' },
      { label: 'Airflow (CFM)', value: '700 - 1400' },
      { label: 'Noise Level', value: '32 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 28,
    slug: 'razor-grey-black-52',
    name: 'Razor Grey + Black - 52"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets.emergentagent.com/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/qzsmjiks_WhatsApp%20Image%202026-06-29%20at%2012.09.49%20PM%20%281%29.jpeg',
    description: 'The Razor Grey + Black is a sleek 52" ceiling fan with a sharp, aerodynamic blade profile in a refined grey and black finish. Its modern, minimalist design makes a bold statement in contemporary interiors.\n\nPart of Bernard Fan Co.\'s precision-engineered lineup, this fan delivers whisper-quiet performance and powerful air circulation, perfect for living rooms, bedrooms, and open-plan spaces.',
    generalSpec: [
      { label: 'Model', value: 'Razor Grey + Black' },
      { label: 'Blade Span', value: '52 inches' },
      { label: 'Number of Blades', value: '3' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '100*20mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '4 - 35' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '95 - 220' },
      { label: 'Airflow (CFM)', value: '3300 - 8400' },
      { label: 'Noise Level', value: '44 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 29,
    slug: 'panther-matte-black-58',
    name: 'Panther Matte Black - 58"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets.emergentagent.com/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/at1add5c_WhatsApp%20Image%202026-06-29%20at%2012.22.30%20PM%20%281%29.jpeg',
    description: 'The Panther Matte Black is a bold 58" ceiling fan finished in a striking matte black with a powerful multi-blade design. Built for both indoor and covered outdoor spaces, it delivers commanding airflow with a sleek, industrial-inspired aesthetic.\n\nPart of Bernard Fan Co.\'s precision-engineered lineup, this fan combines whisper-quiet performance with a dramatic presence, perfect for patios, living rooms, and open-plan spaces.',
    generalSpec: [
      { label: 'Model', value: 'Panther Matte Black' },
      { label: 'Blade Span', value: '58 inches' },
      { label: 'Number of Blades', value: '6' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'Aluminium' },
      { label: 'Motor Spec', value: '172*25mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '7 - 60' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '88 - 175' },
      { label: 'Airflow (CFM)', value: '4500 - 11500' },
      { label: 'Noise Level', value: '44 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 30,
    slug: 'junior-matte-white-44',
    name: 'Junior Matte White - 44"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets.emergentagent.com/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/cu0okbx0_WhatsApp%20Image%202026-06-29%20at%2012.28.02%20PM.jpeg',
    description: 'The Junior Matte White is a compact 44" ceiling fan with a clean matte white finish, perfect for smaller rooms and intimate spaces. Its petal-inspired blade design adds a soft, contemporary touch to any interior.\n\nPart of Bernard Fan Co.\'s precision-engineered lineup, this fan delivers whisper-quiet performance and efficient air circulation, ideal for bedrooms, dining nooks, and cozy living areas.',
    generalSpec: [
      { label: 'Model', value: 'Junior Matte White' },
      { label: 'Blade Span', value: '44 inches' },
      { label: 'Number of Blades', value: '5' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '153*8mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '4 - 39' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '118 - 265' },
      { label: 'Airflow (CFM)', value: '3000 - 7900' },
      { label: 'Noise Level', value: '44 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 31,
    slug: 'junior-dark-wood-black',
    name: 'Junior Dark Wood + Black - 44"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets.emergentagent.com/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/n83skqk5_WhatsApp%20Image%202026-06-29%20at%2012.28.02%20PM%20%281%29.jpeg',
    description: 'The Junior Dark Wood + Black is a compact ceiling fan that pairs rich dark wood blades with a sleek black housing. Its petal-inspired blade design brings warmth and a refined contemporary touch to smaller, intimate spaces.\n\nPart of Bernard Fan Co.\'s precision-engineered lineup, this fan delivers whisper-quiet performance and efficient air circulation, ideal for bedrooms, dining nooks, and cozy living areas.',
    generalSpec: [
      { label: 'Model', value: 'Junior Dark Wood + Black' },
      { label: 'Blade Span', value: '44 inches' },
      { label: 'Number of Blades', value: '5' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '153*8mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '4 - 39' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '118 - 265' },
      { label: 'Airflow (CFM)', value: '3000 - 7900' },
      { label: 'Noise Level', value: '44 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 32,
    slug: 'magnum-matte-black-brown-52',
    name: 'Magnum Matte Black + Brown - 52"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/359bef1864f4392f_WhatsApp%20Image%202026-10-29%20at%2011.14.10%20AM%20%284%29.jpeg',
    description: 'The Magnum Matte Black + Brown is a bold 52" ceiling fan that pairs a sleek matte black housing with warm brown wood-finished blades. Its sweeping, aerodynamic blade profile makes a confident design statement while delivering powerful, whisper-quiet air circulation.\n\nCrafted with Bernard Fan Co.\'s signature precision engineering, the Magnum is perfectly suited to modern living rooms, bedrooms, and open-plan spaces where contemporary style meets effortless performance.',
    generalSpec: [
      { label: 'Model', value: 'Magnum Matte Black + Brown' },
      { label: 'Blade Span', value: '52 inches' },
      { label: 'Number of Blades', value: '5' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'ABS Plastic' },
      { label: 'Motor Spec', value: '153*15mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '5 - 35' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '85 - 177' },
      { label: 'Airflow (CFM)', value: '4400 - 9700' },
      { label: 'Noise Level', value: '44 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  },
  {
    id: 33,
    slug: 'falcon-matte-black-dark-wood-60',
    name: 'Falcon Matte Black + Dark Wood - 60"',
    collection: 'ceiling-fans',
    image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_4d8f70f9-e39f-41c3-b0fe-e1e0dd7b94e6/artifacts/eb4c17a80aac9a1c_WhatsApp%20Image%202026-10-29%20at%2011.14.10%20AM%20%285%29.jpeg',
    description: 'The Falcon Matte Black + Dark Wood is a commanding 60" ceiling fan that fuses a bold matte black housing with sweeping dark wood-finished blades. Its elongated three-blade profile delivers a striking, aerodynamic silhouette that makes a refined statement in larger spaces.\n\nEngineered with Bernard Fan Co.\'s signature precision, the Falcon offers powerful, whisper-quiet air circulation—perfect for spacious living rooms, master suites, and open-plan interiors where presence and performance matter.',
    generalSpec: [
      { label: 'Model', value: 'Falcon Matte Black + Dark Wood' },
      { label: 'Blade Span', value: '60 inches' },
      { label: 'Number of Blades', value: '3' },
      { label: 'Housing Material', value: 'Iron Finished' },
      { label: 'Blade Material', value: 'Solid Wood' },
      { label: 'Motor Spec', value: '153*15mm DC motor' },
      { label: 'Remote Control', value: 'Yes with reversible function' },
      { label: 'Fan Speed', value: '6 speeds' }
    ],
    technicalDetails: [
      { label: 'Motor Type', value: 'Brushless DC (BL-DC)' },
      { label: 'Wattage', value: '5 - 35' },
      { label: 'Voltage', value: '220-240V' },
      { label: 'RPM Range', value: '78 - 159' },
      { label: 'Airflow (CFM)', value: '4700 - 9700' },
      { label: 'Noise Level', value: '44 dB - 50 dB' },
      { label: 'Speed Settings', value: '6' },
      { label: 'Warranty', value: '1 Year With Parts + Lifetime Service' }
    ]
  }
];
